module.exports = __webpack_public_path__ + "static/media/25.39a2f97e.jpg";